import { type UploadedFile } from '@allesauto/core/fileUpload';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

export interface VehicleInformationState {
  vehicleName?: string | null;
  mileage: number | string | null;
  vin: string;
  postalCode: string | null;
  price: string | null;
  isFixedPrice: boolean;
  description: string | null;
  acknowledgementCheckbox: boolean | null;
  isPrivateSeller: boolean | null;
  address: {
    city: string | null;
    zipCode: string | null;
    geoCoordinates: {
      lat: string | null;
      lon: string | null;
    };
  };
}

export interface C2CState {
  garageVehicleId: number | null;
  vehicleInformation: VehicleInformationState;
  images: UploadedFile[];
  status: string;
}

export const initialState: C2CState = {
  garageVehicleId: null,
  vehicleInformation: {
    vehicleName: null,
    mileage: null,
    vin: '',
    postalCode: null,
    price: null,
    isFixedPrice: true,
    description: null,
    acknowledgementCheckbox: false,
    isPrivateSeller: true,
    address: {
      city: null,
      zipCode: null,
      geoCoordinates: {
        lat: null,
        lon: null,
      },
    },
  },
  images: [],
  status: '',
};

const SLICE_NAME = 'c2c/steps';

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    saveGarageVehicleId(
      state,
      action: PayloadAction<{
        garageVehicleId: C2CState['garageVehicleId'];
      }>
    ) {
      state.garageVehicleId = action.payload.garageVehicleId;
    },

    saveVehicleInformation(
      state,
      action: PayloadAction<{
        vehicleInformation: C2CState['vehicleInformation'];
      }>
    ) {
      state.vehicleInformation = action.payload.vehicleInformation;
    },

    saveImages(
      state,
      action: PayloadAction<{
        images: C2CState['images'];
      }>
    ) {
      state.images = action.payload.images;
    },

    saveStatus(state, action: PayloadAction<{ status: C2CState['status'] }>) {
      state.status = action.payload.status;
    },

    reset() {
      return initialState;
    },
  },
});

export const {
  saveGarageVehicleId,
  saveVehicleInformation,
  saveImages,
  saveStatus,
  reset,
} = slice.actions;

export const getVehicleNameState = (state: RootState) =>
  state.pages.c2c.vehicleInformation.vehicleName;

export default slice.reducer;
